function AboutMe() {
  return <>This is a about me page</>;
}

export default AboutMe;
